import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const BEFORE = ['Revisabas varias guías antes de decidir qué hacer con un paciente.', 'Dudabas al elegir el medicamento más adecuado.', 'Perdías tiempo interpretando laboratorios y biomarcadores.', 'Improvisabas cuando un paciente dejaba de responder al tratamiento.', 'Los pacientes abandonaban el tratamiento por falta de comprensión.', 'Invertías horas revisando artículos científicos.'];
const AFTER = ['Sigues una ruta paso a paso que te indica exactamente qué hacer en cada etapa del tratamiento.', 'Tomas decisiones con algoritmos clínicos listos para aplicar según el perfil del paciente.', 'Utilizas tablas y criterios de interpretación organizados para actuar con seguridad.', 'Sabes cuándo ajustar dosis, cambiar estrategias o identificar una meseta terapéutica.', 'Utilizas recursos educativos que mejoran la adherencia desde la primera consulta.', 'Toda la evidencia relevante está organizada en una sola Ruta Clínica práctica.'];
const MINI_STATS = [{
  value: '+300',
  label: 'Algoritmos • Protocolos • Tablas'
}, {
  value: '6',
  label: 'Tomos especializados'
}, {
  value: '100%',
  label: 'Descargable'
}];
export function Transformation() {
  return <section className="w-full bg-cream px-4 py-14" data-id="element-239" data-mp="y6iohx346mqm">
      <div className="mx-auto max-w-3xl" data-id="element-240" data-mp="y83f5bmb5lj7">
        <h2 className="text-center font-display text-[26px] font-bold leading-tight text-navy-900 sm:text-4xl" data-id="element-241" data-mp="1uw9oucy3744c">
          De la incertidumbre clínica a la{' '}
          <span className="italic text-brandblue" data-id="element-242" data-mp="1qx0yzj663qe2">confianza</span> para decidir en cada consulta.
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-center text-[15px] leading-relaxed text-navy/65 sm:text-base" data-id="element-243" data-mp="1m1v2jqf52tbq">
          Deja de perder tiempo buscando respuestas entre múltiples guías y comienza a seguir una Ruta
          Clínica diseñada para evaluar, tratar y dar seguimiento a pacientes con obesidad de forma
          clara, organizada y basada en evidencia.
        </p>

        <div className="mt-9 grid gap-5 md:grid-cols-2" data-id="element-244" data-mp="2sqsvlj3qvl56">
          <div className="rounded-2xl border border-red-100 bg-red-50/50 p-5" data-id="element-245" data-mp="2xpdkwnhgkkeu">
            <h3 className="flex items-center gap-2 text-[13px] font-extrabold uppercase tracking-wider text-red-600" data-id="element-246" data-mp="2jxz14efq8f6q">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-247" data-mp="2nyiy9i0avisv" /> Antes
            </h3>
            <ul className="mt-4 space-y-3" data-id="element-248" data-mp="29zszzz1qvd2x">
              {BEFORE.map(item => <li key={item} className="flex gap-2.5 text-[14px] leading-relaxed text-navy/70" data-id="element-249" data-mp="2eymf1vwojc57">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-red-400" aria-hidden="true" data-id="element-250" data-mp="20yuv7ejhf1ja" />
                  <span data-id="element-251" data-mp="2117j08bx8649">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="rounded-2xl border border-green-200 bg-green-50/60 p-5" data-id="element-252" data-mp="3vcw30ox0eyvi">
            <h3 className="flex items-center gap-2 text-[13px] font-extrabold uppercase tracking-wider text-green-700" data-id="element-253" data-mp="3varu1sk979od">
              <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-254" data-mp="1nqunw65hz2bh" /> Con la Ruta Clínica
            </h3>
            <ul className="mt-4 space-y-3" data-id="element-255" data-mp="1jpsnhlzugk7x">
              {AFTER.map(item => <li key={item} className="flex gap-2.5 text-[14px] leading-relaxed text-navy/80" data-id="element-256" data-mp="1jnpoicgprgr2">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-green-600" aria-hidden="true" data-id="element-257" data-mp="1xirxj8guxm83" />
                  <span data-id="element-258" data-mp="27f3e4anhcy8c">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-3 gap-2 rounded-2xl border border-navy-100 bg-white p-4" data-id="element-259" data-mp="22gjr06x5hgee">
          {MINI_STATS.map(stat => <div key={stat.value} className="text-center" data-id="element-260" data-mp="2gf9pnqzmbo4v">
              <div className="font-display text-2xl font-bold text-navy sm:text-3xl" data-id="element-261" data-mp="2bg6vx2p394c7">{stat.value}</div>
              <div className="mt-1 text-[10px] font-semibold uppercase leading-snug tracking-wide text-navy/50 sm:text-[11px]" data-id="element-262" data-mp="m18t5crjjd7y">
                {stat.label}
              </div>
            </div>)}
        </div>

        <div className="mt-9 flex justify-center" data-id="element-263" data-mp="jgki1deq7o4p">
          <CTAButton label="EMPEZAR MI RUTA CLÍNICA HOY" sublabel="Acceso inmediato por solo $12.99 USD · Pago único" pulse={false} data-id="element-264" data-mp="nixne0pk9k0y" />
        </div>
      </div>
    </section>;
}